import { render, staticRenderFns } from "./QEditQuestions.vue?vue&type=template&id=2440025d&scoped=true&"
import script from "./QEditQuestions.vue?vue&type=script&lang=js&"
export * from "./QEditQuestions.vue?vue&type=script&lang=js&"
import style0 from "./QEditQuestions.vue?vue&type=style&index=0&id=2440025d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2440025d",
  null
  
)

export default component.exports